import { render, staticRenderFns } from "./ProspectAdd.vue?vue&type=template&id=268d6552&"
import script from "./ProspectAdd.vue?vue&type=script&lang=js&"
export * from "./ProspectAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProspectAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports